import { getContext } from 'svelte'

export type SiteScope = 'es' | 'fr'
export type SiteLocale = 'es' | 'fr'

export const DEFAULT_SCOPE: SiteScope = 'es'

/**
 * Get the scope from a string, in a type-safe way.
 */
export function getScope(scope: string): SiteScope {
	if (scope === 'es' || scope === 'fr') {
		return scope as SiteScope
	}
	return DEFAULT_SCOPE as SiteScope
}

/**
 * Retrieves the context scope that belongs to the closest parent component with the specified key.
 * Must be called during component initialisation.
 */
export function getContextScope() {
	const scope = getContext('scope')
	if (scope !== 'es' && scope !== 'fr') {
		console.debug(`Scope is ${scope}`)
	}

	return scope as SiteScope
}

export function getScopeLocale(scope: SiteScope): SiteLocale {
	return scope as SiteLocale
}

/**
 * Return the locale for the scope, in the format `es-ES`.
 */
export function getFullLocale(scope: SiteLocale, separator = '-'): string {
	switch (scope) {
		case 'es':
			return `es${separator}ES`
		case 'fr':
			return `fr${separator}FR`
		default:
			return `en${separator}US`
	}
}